var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { sha256 } from "js-sha256";
import { member } from "../store/login.store";
import { eventMapping } from "../store/sportsbook.store";
import { Storage } from "../lib/localstorege.service";
export default pushNotification;
function pushNotification() {
}
export var getSHA256Hash = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var hash, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, sha256.hex(input.toString())];
            case 1:
                hash = _a.sent();
                return [2 /*return*/, hash];
            case 2:
                e_1 = _a.sent();
                console.log(e_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export function dataLayerPageInfo(pageData) {
    var referrer = Storage.get('userReferrer');
    if (!referrer) {
        referrer = document.referrer;
    }
    var date = new Date();
    var day = date.getDay();
    var isWeekend = (day === 6 || day === 0);
    var hours = date.getHours();
    var dayType = 'sabah';
    if (hours > 6 && hours < 11) {
        dayType = 'sabah';
    }
    else if (hours > 12 && hours < 18) {
        dayType = 'öğle';
    }
    else if (hours > 19 && hours < 23) {
        dayType = 'akşam';
    }
    else {
        dayType = 'gece';
    }
    try {
        var userData = {};
        if (member.id) {
            // userData = member;
            userData["user_id"] = member.id;
            userData["hashed_email"] = getSHA256Hash(member.email);
            userData["hashed_phone"] = getSHA256Hash(member.mobile);
            userData["user_email"] = member.email;
            userData["membership"] = member.get_rank_display;
            userData["user_location"] = member.city;
            userData["balance"] = member.getAvailableBalance();
            userData["mobil_verified"] = member.mobile_verified ? 'evet' : 'hayır';
        }
        // @ts-ignore
        dataLayer.push({
            event: "data_load",
            page_data: pageData,
            user_data: userData,
            event_data: {
                week_type: isWeekend ? 'hafta sonu' : 'hafta içi',
                day_type: dayType,
                logged_in: member.id ? 'evet' : 'hayır',
                entry_channel: referrer
            }
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerAddToCart(item) {
    try {
        // @ts-ignore
        dataLayer.push({ ecommerce: null });
        // @ts-ignore
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "TRY",
                value: 0.0,
                items: [item]
            }
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerSelectItem(item) {
    try {
        // @ts-ignore
        dataLayer.push({ ecommerce: null });
        // @ts-ignore
        dataLayer.push({
            event: "select_item",
            ecommerce: {
                items: [item]
            }
        });
        // @ts-ignore
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                items: [item]
            }
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerRemoveFromCart(item) {
    try {
        // @ts-ignore
        dataLayer.push({ ecommerce: null });
        // @ts-ignore
        dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
                currency: "TRY",
                value: 0.0,
                items: [item]
            }
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerViewItem(couponData) {
    try {
        // @ts-ignore
        dataLayer.push({ ecommerce: null });
        var items = [];
        for (var _i = 0, _a = couponData.cart_data; _i < _a.length; _i++) {
            var cartDatum = _a[_i];
            items.push({
                item_name: cartDatum.event_name,
                item_id: cartDatum.event_id,
                price: 0.0,
                item_category: eventMapping[String(cartDatum.event_id)].sportName,
                item_category2: eventMapping[String(cartDatum.event_id)].competitionGroupName,
                item_category3: eventMapping[String(cartDatum.event_id)].competitionName,
                quantity: 1,
                item_odd: cartDatum.fixed_odds_web,
                high_odds: "hayır",
                item_bet: cartDatum.outcome_display // Seçilen bahis
            });
        }
        // @ts-ignore
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: "TRY",
                value: couponData.amount,
                total_odds: couponData.total_ratio,
                max_revenue: couponData.winning,
                bet_system: couponData.system,
                ticket_count: couponData.coupon_quantity,
                multiplier: couponData.multiply,
                items: items
            }
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerSaveBet(item) {
    try {
        // @ts-ignore
        dataLayer.push({
            event: "save_bet",
            bet_value: item.bet_value,
            total_odds: item.total_odds,
            max_revenue: item.max_revenue,
            bet_system: item.bet_system,
            ticket_count: item.ticket_count,
            multiplier: item.multiplier, // Misli
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerBetError(item) {
    try {
        // @ts-ignore
        dataLayer.push({
            event: "bet_error",
            error_detail: item.error,
            bet_value: item.bet_value,
            total_odds: item.total_odds,
            max_revenue: item.max_revenue, // Maksimum kazanç tutarı
        });
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerPushEvent(event, item) {
    try {
        item['event'] = event;
        item['user_id'] = item.id;
        item["hashed_email"] = getSHA256Hash(item.email);
        item["hashed_phone"] = getSHA256Hash(item.mobile);
        item["user_email"] = item.email;
        // @ts-ignore
        dataLayer.push(item);
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerPushEventLogin(event, item) {
    try {
        var date = new Date();
        var pushEvent = {};
        pushEvent['event'] = event;
        pushEvent['user_id'] = item.id;
        pushEvent["hashed_email"] = getSHA256Hash(item.email);
        pushEvent["hashed_phone"] = getSHA256Hash(item.mobile);
        pushEvent["user_email"] = item.email;
        pushEvent["user_age"] = Number(date.getFullYear()) - Number(item.birthday.split('-')[0]);
        pushEvent["balance"] = item.debit_balance;
        pushEvent["create_date"] = item.create_date;
        pushEvent["date_joined"] = item.date_joined;
        pushEvent["rank"] = item.get_rank_display;
        pushEvent["user_gender"] = item.gender;
        pushEvent["point_balance"] = item.point_balance;
        pushEvent["sms_notification"] = item.sms_notification ? 'evet' : 'hayır';
        pushEvent["push_notification"] = item.push_notification ? 'evet' : 'hayır';
        pushEvent["mail_notification"] = item.mail_notification ? 'evet' : 'hayır';
        // @ts-ignore
        dataLayer.push(pushEvent);
    }
    catch (e) {
        console.log(e);
    }
}
export function dataLayerSignUpError(detail) {
    try {
        // @ts-ignore
        dataLayer.push({ "event": "sign_up_error", "error_detail": detail });
    }
    catch (e) {
        console.log(e);
    }
}
var purchaseDataLayerEcommerce = {};
export function savePurchaseData(cartItems, betSlipOptions) {
    try {
        var items = [];
        for (var _i = 0, cartItems_1 = cartItems; _i < cartItems_1.length; _i++) {
            var cartDatum = cartItems_1[_i];
            items.push({
                item_name: cartDatum.sportEvent.eventName.toString(),
                item_id: cartDatum.sportEvent.eventId.toString(),
                price: 0.0,
                item_category: eventMapping[String(cartDatum.sportEvent.eventId)].sportName,
                item_category2: eventMapping[String(cartDatum.sportEvent.eventId)].competitionGroupName,
                item_category3: eventMapping[String(cartDatum.sportEvent.eventId)].competitionName,
                quantity: 1,
                item_odd: cartDatum.outcome.fixedOddsWeb.toString(),
                high_odds: Number(cartDatum.outcome.fixedOddsWeb) != Number(cartDatum.outcome.fixedOdd) ? 'evet' : "hayır",
                item_bet: cartDatum.outcomeName.toString() // Seçilen bahis
            });
        }
        purchaseDataLayerEcommerce = {
            value: betSlipOptions.systemCombinations.length * betSlipOptions.betSlipMultiply * betSlipOptions.betSlipQuantity,
            currency: "TRY",
            tax: 0.0,
            shipping: 0.00,
            total_odds: betSlipOptions.totalRatio,
            max_revenue: betSlipOptions.totalRatio * betSlipOptions.betSlipMultiply * betSlipOptions.betSlipQuantity,
            bet_system: betSlipOptions.systemCombinations.length > 1 ? 'evet' : 'hayır',
            ticket_count: betSlipOptions.betSlipQuantity,
            multiplier: betSlipOptions.betSlipMultiply,
            items: items,
        };
    }
    catch (e) {
    }
}
export function dataLayerPurchase(approvedCode) {
    try {
        // @ts-ignore
        dataLayer.push({ ecommerce: null });
        purchaseDataLayerEcommerce['transaction_id'] = approvedCode.toString();
        var purchaseDataLayer = {
            event: "purchase",
            ecommerce: purchaseDataLayerEcommerce
        };
        // @ts-ignore
        dataLayer.push(purchaseDataLayer);
    }
    catch (e) {
        console.log(e);
    }
}
